import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { MatchLeadMLBState } from './MatchLeadMLB.state';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { AmericanSportMatchLead } from 'src/domains/sportsbook/webview/components/matchLead/americanSportMatchLead/AmericanSportMatchLead';

interface PropsType {
    event: EventModel
}

export const MatchLeadMLB = observer<PropsType>('MatchLeadMLB', ({ event }) => {
    const [state] = useState(() => new MatchLeadMLBState(event));

    return <AmericanSportMatchLead state={state} />;
});
